import styled from 'styled-components';

import colours from 'theme/atoms/colours';

export const Section = styled('section')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled('button')`
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  color: ${colours.neutral[900]};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 10px 0;
  width: 100%;

  &:focus-visible {
    outline: 2px solid ${colours.neutral[400]};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const Chevron = styled('span')<{ $expanded: boolean }>`
  align-items: center;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  transform: rotate(${({ $expanded }) => ($expanded ? '0deg' : '180deg')});
  transition: transform 0.2s ease;
  width: 20px;

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const Body = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
